import React from 'react';
import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import { getStaticContent } from '../../../actions/siteadmin/ContentPageAction';

async function action({ locale, store }) {
    const dataResult = await new Promise((resolve) => {
        require.ensure([], (require) => {
            try {
                resolve(require(`./driverPrivacyPolicy.${locale}.md`));
            } catch (e) {
                resolve(require('./driverPrivacyPolicy.md'));
            }
        }, 'driverPrivacyPolicy');
    });

    await store.dispatch(getStaticContent(4));
    let getContentPage = store.getState().page;
    if (getContentPage && getContentPage.staticPageData) {
        return {
            title: getContentPage.staticPageData.metaTitle,
            description: getContentPage.staticPageData.metaDescription,
            component: <Layout><Page html={getContentPage.staticPageData.content} title={getContentPage.staticPageData.metaTitle} /></Layout>,
        };

    } else {
        return {
            title: dataResult.title,
            component: <Layout><Page {...dataResult} /></Layout>,
        };
    }
}

export default action